<template>
  <ion-page>
    <ion-header>
      <HeaderWithBackButtonComponent title="メール認証確認" :show-button="false" />
    </ion-header>
    
    <ion-content>
      <ion-header style="font-weight: bold" class="ion-margin-bottom ion-margin-top ion-text-center">認証コードを入力してください</ion-header>

      <div class="ion-padding-horizontal">
        <ion-label>入力いただいたメールアドレスに、<br/>認証コード通知メールを送信しました。</ion-label>
        <br/>
        <ion-label class="ion-margin-bottom">メールに記載されている認証コードを入力して、<br/>メールアドレス確認を完了させてください。</ion-label>

        <br/><br/>
        <ion-label>認証コード</ion-label>
        <ion-input class="ion-margin-top border ion-padding-start" fill="outline" style="border: black 1px solid" v-model="code"></ion-input>
        <ion-text color="danger" v-if="errors && errors.code">{{ errors.code }}</ion-text>
        <ion-button class="ion-margin-bottom ion-margin-top primary-button" expand="block" @click="verifyCode">認証する</ion-button>
        <ion-label class="ion-margin-top">24時間以内にメールアドレス確認が完了しない場合は、認証コードは無効となります。</ion-label>
      </div>
    </ion-content>
  </ion-page>
</template>

<script setup lang="ts">
import { useForm, useFormErrors, useField } from 'vee-validate';
import {
  IonPage,
  IonLabel,
  IonText,
  IonInput,
  IonButton, IonHeader,
} from "@ionic/vue";
import StorageService from '../../utils/StorageService'
import HeaderWithBackButtonComponent from "../../components/HeaderWithBackButton.vue";
import {useRoute, useRouter} from 'vue-router';
import * as yup from 'yup';
import { verifyOtpCode } from '@/actions/verify-otp-code'
import  { usePushNotification } from '@/composables/usePushNotification'
import {setCapacitorCookie} from "@/helpers/cookie";

const { getToken, sendNotificationToken } = usePushNotification()
const router = useRouter()
const route = useRoute();

const props = defineProps({
  authenticatedHref: String,
  isChangeEmailPage: {
    type: Boolean,
    default: false,
  },
})

const emits = defineEmits(['form-submit-verify'])

const urlString = window.location.href
const url = new URL(urlString)
const email = url.searchParams.get("email")

const schema = yup.object({
  code: yup.string()
      .required('認証コードは必ず指定してください。')
      .matches(/^[0-9]{6}$/, '認証コードが正しくありません')
})

const formVerifyCode = useForm({
  validationSchema: schema
})

const { value: code } = useField<number>("code")
// FIXME: any やめる！！！
const errors = useFormErrors() as any;

async function verifyCode() {
  const resp = await formVerifyCode.validate();

  if (props.isChangeEmailPage) {
    emits('form-submit-verify', {code: formVerifyCode.values.code, email: email, formVerifyCode: formVerifyCode})
    return
  }
  // 早期脱出
  if (!resp.valid || !email) {
    return
  }

  // await で書く、then は使わない、catch は async 関数に続けて（=Promise から）呼ぶ
  const response = await verifyOtpCode({
    email: email,
    code: formVerifyCode.values.code,
    device_uuid: await StorageService.get('deviceUuid'),
  }).catch((err: any) => {
    if (err.response?.status == 422) {
      formVerifyCode.setErrors(err.response.data.errors)
    }
  })
  if (!response?.status) {
    return
  }
  if (response.data.is_logged) {
    await setCapacitorCookie({
      key: 'token',
      value: response.data.access_token,
      path: '/'
    })

    // デバイストークンを送信
    const token = await getToken()
    await sendNotificationToken(token)
    console.log('デバイストークン送信 ログイン後')
    if(route.query.type == 'withdraw') {
      return router.push({name: 'WebWithdrawalWithdraw'})
    }
    else if(route.query.type == 'forgot') {
      return router.push({name: 'WebWithdrawalNewPassword'})
    }
  }
}
</script>
